import { Pipe, PipeTransform } from '@angular/core';

import { IMoment, moment } from '@lib/moment';

@Pipe({ name: 'timeDiff' })
export class TimeDifferencePipe implements PipeTransform {
  public transform(start: string | IMoment, end: string | IMoment, roundMinutes: boolean = true): string {
    if (!start || !end) return '';

    const startDate = moment(start);
    const endDate = moment(end);
    const timeDiffInSeconds = Math.abs(endDate.diff(startDate, 'seconds'));
    if (timeDiffInSeconds < 60) return `${timeDiffInSeconds}s`;
    const timeInMinutes = timeDiffInSeconds / 60;
    const roundedTimeInMinutes = Math.round(timeInMinutes);
    const timeInMilliseconds = (roundMinutes ? roundedTimeInMinutes : timeInMinutes) * 60 * 1000;
    const timeDuration = moment.duration(timeInMilliseconds);
    const timeDiffInHrs: number = timeDuration.hours();
    const timeDiffInDays: number = timeDuration.days();
    if (timeDiffInDays < 1) {
      return timeDiffInHrs ? `${timeDiffInHrs}h ${timeDuration.minutes()}m ` : `${timeDuration.minutes()}m`;
    } else {
      return `${timeDiffInDays}d ${timeDiffInHrs}h`;
    }
  }
}
